import { ProConfigProvider } from '@ant-design/pro-components';
import { useTheme } from '@zhiyue/core';
import { App, ConfigProvider } from 'antd';
import React from 'react';
import { getAppTheme } from './config';

// This boundary is also mounted inside ProLayout, whose own provider can
// otherwise override the algorithm used by business content and its Portals.
export const ThemeBoundary: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { navTheme } = useTheme();
  const config = React.useMemo(
    () => getAppTheme(navTheme === 'realDark' ? 'realDark' : 'light'),
    [navTheme],
  );
  return (
    <ConfigProvider theme={config}>
      <ProConfigProvider dark={navTheme === 'realDark'}>
        <App>{children}</App>
      </ProConfigProvider>
    </ConfigProvider>
  );
};
